import OrganisationTypeEnum from '@constants/enums/organisation/type';

import ReceivingAgentApi from '@packages/receiving-agents/api';

import { Organisation } from '@/models';

export class ReceivingAgent extends Organisation {
    static name = 'ReceivingAgent';
    static entity = 'receivingAgents';
    static Api = ReceivingAgentApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.RECEIVINGAGENT).nullable()
        };
    }
}

export default ReceivingAgent;
